/**
 * @author lifei
 * 功能：供应商发货通知单列表
 */
import { Service } from '@/tools'

export class ProcureSupplierAbnormal<T extends TProcure.SupplierAbnormal> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TProcure.SupplierAbnormal}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  /**
   * 功能：更新异常标签
   * /api/procure/supplier/abnormal/v1/updateExceptionType
   */
  updateExceptionType = <K extends T['ApiUpdateExceptionType']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiUpdateExceptionType', data, '更新成功')

  /**
   * 功能：采购单了结
   *  /api/procure/supplier/abnormal/v1/endProcureOrder
   */
  endProcureOrder = <K extends T['ApiEndProcureOrder']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiEndProcureOrder', data, '了结成功')

  /**
   * 功能：异常处理确认（补采购单-拒收）
   *  /api/procure/supplier/abnormal/v1/abnormalConfirm
   */
  abnormalConfirm = <K extends T['ApiAbnormalConfirm']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiAbnormalConfirm', data, '操作成功')

  /**
   * 功能：信息确认
   *  /api/procure/supplier/abnormal/v1/confirmInformation
   */
  confirmInformation = <K extends T['ApiConfirmInformation']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiConfirmInformation', data, '操作成功')

  /**
   * 功能：查询源供应商发货清单明细数据（品种替换-转移）
   *  /api/procure/supplier/abnormal/v1/selectSourceOrderList
   */
  selectSourceOrderList = <K extends T['ApiSelectSourceOrderList']>(data: K['req']): Promise<K['res']['data']> =>
    this.post2('v1/ApiSelectSourceOrderList', data)
}
